// Deshacer / rehacer del editor: pila de instantáneas JSON de {sources, fields, maps}. Cada acción
// discreta pasa por mutate(); los textos (nombre, descripción, cron…) usan el deshacer nativo.
import { ref } from 'vue';

/**
 * @param {() => object} get estado actual
 * @param {(snap: object) => void} set restaura un estado
 * @param {number} max niveles
 */
export function useHistory(get, set, max = 30) {
  const undoStack = ref([]);
  const redoStack = ref([]);
  const snapshot = () => JSON.stringify(get());

  /** Ejecuta fn y apila el estado anterior si algo cambió. @returns lo que devuelva fn */
  function mutate(label, fn) {
    const before = snapshot();
    const out = fn();
    if (snapshot() !== before) {
      undoStack.value.push({ label, snap: before });
      if (undoStack.value.length > max) undoStack.value.shift();
      redoStack.value = [];
    }
    return out;
  }

  function swap(from, to) {
    const e = from.value.pop();
    if (!e) return null;
    to.value.push({ label: e.label, snap: snapshot() });
    set(JSON.parse(e.snap));
    return e.label;
  }

  return {
    mutate,
    snapshot,
    undo: () => swap(undoStack, redoStack),
    redo: () => swap(redoStack, undoStack),
    canUndo: () => undoStack.value.length > 0,
    canRedo: () => redoStack.value.length > 0,
    /** Vuelve a una instantánea (apilando el estado actual para poder deshacerlo). */
    restore(label, snap) {
      mutate(label, () => set(JSON.parse(snap)));
    },
  };
}
